'use client';

import { c as _c } from "react/compiler-runtime";
import { XMarkIcon } from '@heroicons/react/24/outline';
export const TopNavV5MobileCloseHeader = t0 => {
  const $ = _c(3);
  const {
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <XMarkIcon className="size-6 stroke-[2px]" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClick) {
    t2 = <div className="flex items-center justify-end p-4 pb-0"><button className="rounded-md p-1 text-bodi-white transition-colors hover:bg-bodi-gray-dark" onClick={onClick}>{t1}</button></div>;
    $[1] = onClick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};